import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';
import { notification } from 'antd';

export const createStore: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.CREATE_STORE_ACTIONS.REQUESTED),
    switchMap(({ payload: { store, file } }) =>
      storeApi.createStore(store).pipe(
        switchMap(({ store: { id } }) => {
          if (file) {
            return storeApi.uploadPhoto(id, file).pipe(
              switchMap(() =>
                of(actions.createStoreSucceeded(), push('/stores')),
              ),
              catchError(error => {
                return of(push('/stores'));
              }),
            );
          }

          return of(actions.createStoreSucceeded(), push('/stores'));
        }),
        catchError(error => {
          notification.error({
            message: error.response.message,
          });
          console.error('error create', error);
          return of(actions.createStoreFailed(error.message.toString()));
        }),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/services/epics/createStore.ts